module.exports = __webpack_public_path__ + "img/PTE90Img.947305f6.png";